import script from "./TicketView.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketView.vue?vue&type=script&setup=true&lang=js"

import "./TicketView.vue?vue&type=style&index=0&id=0346b145&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0346b145"]])

export default __exports__